import { TEXT } from '../../../../shared/Helpers/colors';
import { Text } from '../../../../shared/uiComponents';
import { InsuranceAuthorizationActions, StatusWithTemporaryIndicator } from './tableInfo';

import { ActiveAuthorizationProperties } from '../../../../redux/API/ClientAPIHelpers/insuranceAuthorizationProperties';
import { useSelector } from '../../../../redux/store';
import { AdminTypes } from '../../../../components/Menu';

import './EditInsuranceAuthorization/index.scss';

export const InsuranceAuthorizationMobileCard = ({ item }: { item: ActiveAuthorizationProperties }) => {
	const role = useSelector((state) => state.account.role);
	const isAdmin = role?.section.id === AdminTypes.admin;
	const { type, authorizationDetails, endDate, isTemporary } = item;

	return (
		<div className="insuranceAuthorizationMobileCard">
			<div className="insuranceAuthorizationMobileCardHeader">
				<div className="mobileCardHeaderRow">
					{isAdmin && <InsuranceAuthorizationActions row={item} />}
					<Text title={type.name} type="psm" fontWeight="medium" color={TEXT.PRIMARY} />
				</div>
				<StatusWithTemporaryIndicator endDate={endDate} isTemporary={isTemporary} />
			</div>
			{authorizationDetails.map((detail) => (
				<div className="insuranceAuthorizationMobileCardBody" key={detail.id}>
					<div className="insuranceAuthorizationMobileCardBodyItem">
						<Text title="Session:" type="pxs" fontWeight="regular" color={TEXT.TERTIARY} />
						<Text title={detail.sessionType.name} type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					</div>
					<div className="insuranceAuthorizationMobileCardBodyItem">
						<Text title="Frequency type:" type="pxs" fontWeight="regular" color={TEXT.TERTIARY} />
						<Text title={detail.frequency.name} type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					</div>
					<div className="insuranceAuthorizationMobileCardBodyItem">
						<Text title="Total:" type="pxs" fontWeight="regular" color={TEXT.TERTIARY} />
						<Text
							title={detail.totalHours ? `${detail.totalHours.toString()} h` : '0'}
							type="psm"
							fontWeight="medium"
							color={TEXT.SECONDARY}
						/>
					</div>
					<div className="insuranceAuthorizationMobileCardBodyItem">
						<Text title="Weekly:" type="pxs" fontWeight="regular" color={TEXT.TERTIARY} />
						<Text
							title={detail.hoursPerWeek ? `${detail.hoursPerWeek.toString()} h` : '0'}
							type="psm"
							fontWeight="medium"
							color={TEXT.SECONDARY}
						/>
					</div>
				</div>
			))}
		</div>
	);
};
